import Table from '@/components/table/components/Table.tsx';
import tourPlannedTransactionsApi from '@/features/dashboard/tours/api/tourPlannedTransactionsApi.ts';
import { tourPlannedTransactionsApiQueryKeys } from '@/features/dashboard/tours/api/tourPlannedTransactionsApi.queryKeys.ts';
import { tourRoute } from '@/features/dashboard/tours/routes/tourRoute.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { ListSearch } from '@/components/table/routes/listSearchParams.ts';

interface TourTransactionsTableProps {
  listSearch?: ListSearch;
}

const TourTransactionsTable = ({ listSearch }: TourTransactionsTableProps) => {
  const { tourId } = tourRoute.useParams();

  return (
    <Table
      listSearch={listSearch}
      queryKey={tourPlannedTransactionsApiQueryKeys.byTour(tourId)}
      fetchData={(pr, fc: FilterCriteriaDto) =>
        tourPlannedTransactionsApi.getAll(tourId, pr, fc)
      }
      fetchTableDef={() =>
        tourPlannedTransactionsApi.getTableDefinition(tourId)
      }
      title="Zaplanowane wpłaty"
    />
  );
};

export default TourTransactionsTable;
